<template>
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.39144 9.81881C6.4865 9.91946 6.54241 10.0481 6.54241 10.1879V17.9996L9.89749 15.131V10.1879C9.89749 10.0481 9.95341 9.91946 10.0485 9.81881L15.7241 3.63428H0.715759L6.39144 9.81881Z"
      fill="currentColor" />
    <path d="M16.4399 0H0V2.51631H16.4399V0Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'File',
};
</script>
